import StyledLink from '../StyledLink'
import {
  ADD,
  CONTROLLER,
  ENVIRONMENTS
} from '../routes'
import type { Props } from '../types'

const LinkToAddEnvironment = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + CONTROLLER + '/' + ENVIRONMENTS + '/' + ADD}
  >
    {children}
  </StyledLink>

export default LinkToAddEnvironment
